module.exports = __webpack_public_path__ + "img/144.1470d0e0.jpg";